import React from 'react';
import Icon from '../Icon';

const FAVORITE_ICON = 'img/favorite@3x.png',
    FAVORITED_ICON = 'img/favorited.png';

const FavoriteIcon = props => {
    const {className='', active} = props;

    return <Icon className={className} src={active ? FAVORITED_ICON : FAVORITE_ICON} />;
};

export default FavoriteIcon;
